module.exports = __webpack_public_path__ + "static/media/phone-slash.1ab64cd2.svg";